import { CommonModule, DatePipe, PercentPipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ChartsModule } from 'ng2-charts';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { SliderModule } from 'primeng/slider';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { ComumModule } from '../../../shared/comum.module';
import { translateLoaderNBS } from '../../../shared/translate-loader/translateLoader';
import { ConsultaVendaAcessoriosComponent } from './consulta-venda-acessorios.component';
import { ConsultaVendaAcessoriosService } from './consulta-venda-acessorios.service';

@NgModule({
  imports: [
    HttpClientModule,
    BrowserAnimationsModule,
    TableModule,
    ButtonModule,
    ToastModule,
    CalendarModule,
    SliderModule,
    MultiSelectModule,
    ContextMenuModule,
    DialogModule,
    DropdownModule,
    InputTextModule,
    FormsModule,
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule,
    ChartsModule,
    NgbModule,
    TranslateModule.forRoot(translateLoaderNBS),
    TooltipModule
  ],
  exports: [
    ConsultaVendaAcessoriosComponent
  ],
  declarations: [
    ConsultaVendaAcessoriosComponent,
  ],
  providers: [
    ConsultaVendaAcessoriosService,
    DatePipe,
    PercentPipe
  ]
})
export class ConsultaVendaAcessoriosModule { }
